import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/ScrollToTop";
import { PageTransition } from "@/components/PageTransition";

// Pages
import EntryGate from "@/pages/EntryGate";
import BuilderHome from "@/pages/BuilderHome";
import BuilderRequest from "@/pages/BuilderRequest";
import BuilderBuyBox from "@/pages/BuilderBuyBox";
import SellerHome from "@/pages/SellerHome";
import SellSubmit from "@/pages/SellSubmit";
import Faith from "@/pages/Faith";
import About from "@/pages/About";
import Prayer from "@/pages/Prayer";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminPrayers from "@/pages/admin/AdminPrayers";
import AdminAudit from "@/pages/admin/AdminAudit";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<EntryGate />} />
      <Route path="/builder" element={<BuilderHome />} />
      <Route path="/builder/request" element={<BuilderRequest />} />
      <Route path="/builder/buybox" element={<BuilderBuyBox />} />
      <Route path="/seller" element={<SellerHome />} />
      <Route path="/sell/submit" element={<SellSubmit />} />
      <Route path="/faith" element={<Faith />} />
      <Route path="/about" element={<About />} />
      <Route path="/prayer" element={<Prayer />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      
      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/leads" element={<AdminLeads />} />
      <Route path="/admin/prayers" element={<AdminPrayers />} />
      <Route path="/admin/audit" element={<AdminAudit />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <PageTransition>
            <AppRoutes />
          </PageTransition>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
